import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/logo_myculture.png'
import _imports_1 from '@/assets/icons/navigate_right_black_24px.png'
import _imports_2 from '@/assets/icons/white_arrow_right_24px.png'
import _imports_3 from '@/assets/icons/white_navigate_back_24px.png'


const _withScopeId = n => (_pushScopeId("data-v-35de2cb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-navbar-for-test" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  src: _imports_0,
  alt: "Happily logo",
  class: "company-logo-image",
  style: {"width":"18rem"}
}
const _hoisted_4 = {
  key: 0,
  class: "progrees-container mx-auto flex-center center"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "fs-13 fw-700 mb-8" }
const _hoisted_7 = { class: "fs-12 mt-8" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex-center ml-auto" }
const _hoisted_10 = { class: "max-m-none mr-16" }
const _hoisted_11 = {
  key: 0,
  src: _imports_1,
  class: "icon-24",
  alt: "navigate_right_black_24px"
}
const _hoisted_12 = {
  key: 1,
  src: _imports_2,
  class: "icon-24",
  alt: "icons_white_arrow_right_24px"
}
const _hoisted_13 = {
  key: 1,
  class: "flex-center ml-auto"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "white_navigate_back_24px",
  class: "icon-24 icon-invert-color"
}, null, -1))
const _hoisted_15 = { class: "max-m-none ml-16" }
const _hoisted_16 = {
  key: 0,
  class: "max-m-none mr-16"
}
const _hoisted_17 = {
  key: 1,
  class: "max-m-none mr-16"
}
const _hoisted_18 = {
  key: 2,
  src: _imports_1,
  class: "icon-24",
  alt: "navigate_right_black_24px"
}
const _hoisted_19 = {
  key: 3,
  src: _imports_2,
  class: "icon-24",
  alt: "icons_white_arrow_right_24px"
}
const _hoisted_20 = {
  key: 2,
  class: "flex-center ml-auto"
}
const _hoisted_21 = { class: "max-m-none mr-16" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "icons_white_arrow_right_24px",
  class: "icon-24 icon-invert-color"
}, null, -1))
const _hoisted_23 = { class: "assessment-card-container" }
const _hoisted_24 = {
  key: 0,
  class: "assessment-content mb-32"
}
const _hoisted_25 = { class: "width-max-520" }
const _hoisted_26 = { class: "card-title" }
const _hoisted_27 = { class: "fs-16 mt-12" }
const _hoisted_28 = { class: "fs-16 mt-16" }
const _hoisted_29 = { class: "text-underline" }
const _hoisted_30 = { class: "min-m-flex-mid min-m-mt-80 max-m-mt-40 width-max-520" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "icons_white_arrow_right_24px",
  class: "icon-24 ml-16 icon-invert-color"
}, null, -1))
const _hoisted_32 = {
  key: 1,
  class: "assessment-content mb-32"
}
const _hoisted_33 = {
  key: 0,
  class: "width-max-520"
}
const _hoisted_34 = { class: "card-title" }
const _hoisted_35 = { class: "fs-16 mt-12" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "fs-16 mt-24 mb-16 fc-CC308A" }
const _hoisted_39 = ["onUpdate:modelValue", "onInput"]
const _hoisted_40 = { class: "text-container" }
const _hoisted_41 = { class: "text" }
const _hoisted_42 = {
  key: 2,
  class: "assessment-content mb-32"
}
const _hoisted_43 = {
  key: 0,
  class: "width-max-520"
}
const _hoisted_44 = { class: "card-title" }
const _hoisted_45 = { class: "fs-16 mt-12" }
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "fs-16 mt-24 mb-16 fc-CC308A" }
const _hoisted_49 = ["onUpdate:modelValue", "onInput"]
const _hoisted_50 = { class: "text-container" }
const _hoisted_51 = { class: "text" }
const _hoisted_52 = {
  key: 3,
  class: "assessment-content mb-32"
}
const _hoisted_53 = {
  key: 0,
  class: "width-max-520"
}
const _hoisted_54 = { class: "card-title" }
const _hoisted_55 = { class: "fs-16 mt-12" }
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { class: "fs-16 mt-24 mb-16 fc-CC308A" }
const _hoisted_59 = ["onUpdate:modelValue", "onInput"]
const _hoisted_60 = { class: "text-container" }
const _hoisted_61 = { class: "text" }
const _hoisted_62 = {
  key: 4,
  class: "assessment-content mb-32"
}
const _hoisted_63 = {
  key: 0,
  class: "width-max-520"
}
const _hoisted_64 = { class: "card-title" }
const _hoisted_65 = { class: "fs-16 mt-12" }
const _hoisted_66 = ["innerHTML"]
const _hoisted_67 = ["innerHTML"]
const _hoisted_68 = { class: "fs-16 mt-24 mb-16 fc-CC308A" }
const _hoisted_69 = ["onUpdate:modelValue", "onInput"]
const _hoisted_70 = { class: "text-container" }
const _hoisted_71 = { class: "text" }
const _hoisted_72 = {
  key: 5,
  class: "assessment-content mb-32"
}
const _hoisted_73 = {
  key: 0,
  class: "width-max-520"
}
const _hoisted_74 = { class: "card-title" }
const _hoisted_75 = { class: "fs-16 mt-12" }
const _hoisted_76 = ["innerHTML"]
const _hoisted_77 = ["innerHTML"]
const _hoisted_78 = { class: "fs-16 mt-24 mb-16 fc-CC308A" }
const _hoisted_79 = ["onUpdate:modelValue", "onInput"]
const _hoisted_80 = { class: "text-container" }
const _hoisted_81 = { class: "text" }
const _hoisted_82 = {
  key: 6,
  class: "assessment-content mb-32"
}
const _hoisted_83 = {
  key: 0,
  class: "width-max-520"
}
const _hoisted_84 = { class: "card-title" }
const _hoisted_85 = { class: "fs-16 mt-12" }
const _hoisted_86 = ["innerHTML"]
const _hoisted_87 = ["innerHTML"]
const _hoisted_88 = { class: "fs-16 mt-24 mb-16 fc-CC308A" }
const _hoisted_89 = ["onUpdate:modelValue", "onInput"]
const _hoisted_90 = { class: "text-container" }
const _hoisted_91 = { class: "text" }
const _hoisted_92 = {
  key: 7,
  class: "assessment-content mb-32"
}
const _hoisted_93 = { class: "width-max-520" }
const _hoisted_94 = { class: "fs-24 fw-900" }
const _hoisted_95 = { class: "fs-16 mt-12" }
const _hoisted_96 = { class: "flex-center mt-24" }
const _hoisted_97 = { class: "max-m-none mr-16" }
const _hoisted_98 = { class: "max-m-none mr-16" }
const _hoisted_99 = {
  key: 8,
  class: "assessment-content mb-32"
}
const _hoisted_100 = { class: "width-max-520" }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { class: "card-title" }
const _hoisted_103 = { class: "fs-16 mt-12" }
const _hoisted_104 = { class: "fw-700" }
const _hoisted_105 = { class: "fs-16 mt-12" }
const _hoisted_106 = { class: "flex-mid" }
const _hoisted_107 = { key: 1 }
const _hoisted_108 = { class: "card-title" }
const _hoisted_109 = { class: "fs-16 mt-12" }
const _hoisted_110 = { class: "fw-700" }
const _hoisted_111 = { class: "fs-16 mt-16" }
const _hoisted_112 = { class: "flex-mid" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "icons_white_arrow_right_24px",
  class: "icon-24 ml-16 icon-invert-color"
}, null, -1))
const _hoisted_114 = {
  key: 0,
  class: "mock-menu-container-buttom"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["menu-container flex-center fixed", {
      'bottom-mobile': _ctx.partAnwser,
    }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass({
          'max-m-none': _ctx.partAnwser,
        })
        }, [
          (_ctx.companyLogoUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.companyLogoUrl,
                alt: "Happily logo",
                class: "company-logo-image",
                style: {"width":"18rem"}
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3))
        ], 2),
        (_ctx.progressShowing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("main.Culture_Profile")), 1),
                _createVNode(_component_el_progress, {
                  percentage: ((_ctx.percentageLabel - _ctx.timer) / _ctx.percentageLabel) * 100,
                  "show-text": false,
                  color: _ctx.companyColor
                }, null, 8, ["percentage", "color"]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("assessmentTest.minutes_remaining_defore")) + " " + _toDisplayString(_ctx.timerLabel) + " " + _toDisplayString(_ctx.$t("assessmentTest.minutes_remaining_after")), 1)
              ])
            ]))
          : (_ctx.step == 'opened_question')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " "))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.step == 'OAIC_archetypes_1_6')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextBTN_OAIC_dominant())),
                class: _normalizeClass(["ml-auto btn btn-50 btn-primary", { 'disable-true': _ctx.OAIC_dominant_characteristicsMax != 0 }])
              }, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("btn.Next")), 1),
                (_ctx.OAIC_dominant_characteristicsMax == 0 && _ctx.isLightColor)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                  : (_openBlock(), _createElementBlock("img", _hoisted_12))
              ], 2))
            : (
            _ctx.step == 'OAIC_archetypes_2_6' ||
            _ctx.step == 'OAIC_archetypes_3_6' ||
            _ctx.step == 'OAIC_archetypes_4_6' ||
            _ctx.step == 'OAIC_archetypes_5_6' ||
            _ctx.step == 'OAIC_archetypes_6_6'
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backBTN_OAIC_dominant && _ctx.backBTN_OAIC_dominant(...args))),
                    class: "btn btn-50 btn-primary mr-16"
                  }, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("btn.Previous")), 1)
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextBTN_OAIC_dominant())),
                    class: _normalizeClass(["ml-auto btn btn-50 btn-primary", { 'disable-true': _ctx.nextBTN_OAIC_dominantValidate }])
                  }, [
                    (_ctx.step == 'OAIC_archetypes_6_6')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("btn.Finish")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("btn.Next")), 1)),
                    (_ctx.nextBTN_OAIC_dominantValidate == false && _ctx.isLightColor)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                      : (_openBlock(), _createElementBlock("img", _hoisted_19))
                  ], 2)
                ]))
              : (_ctx.step == 'opened_question')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.finishOpenedQuestion && _ctx.finishOpenedQuestion(...args))),
                      class: "ml-auto btn btn-50 btn-primary"
                    }, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("btn.Finish")), 1),
                      _hoisted_22
                    ])
                  ]))
                : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mock-menu-container", {
      'max-m-none': _ctx.partAnwser,
    }])
    }, null, 2),
    _createElementVNode("div", _hoisted_23, [
      (_ctx.step == 'introduce_OAIC_archetypes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("question.cultureProfile.Culture_Profile")), 1),
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("question.cultureProfile.The_Happily_Culture_Profile")), 1),
              _createElementVNode("div", _hoisted_28, [
                _createTextVNode(_toDisplayString(_ctx.$t("question.cultureProfile.Which_culture_type_should")) + " ", 1),
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("question.cultureProfile.Takes")) + " " + _toDisplayString(_ctx.extratime + 5) + " " + _toDisplayString(_ctx.$t("question.cultureProfile.minutes")), 1),
                _createTextVNode("  " + _toDisplayString(_ctx.$t("question.cultureProfile.to_go_evaluate_your_ideal")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (
            (_ctx.step = 'OAIC_archetypes_1_6'),
              _ctx.clearIntervalSession(),
              _ctx.countDownTime()
          )),
                class: "mx-auto btn btn-50 btn-primary"
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("btn.Get_Started")), 1),
                _hoisted_31
              ])
            ])
          ]))
        : (_ctx.step == 'OAIC_archetypes_1_6')
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              (_ctx.oaicArchetypes.scenarios)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.lang(_ctx.oaicArchetypes.scenarios.dominantCharacteristics, "title")) + " (" + _toDisplayString(_ctx.oaicArchetypes.scenarios.dominantCharacteristics.order) + "/6) ", 1),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("question.cultureProfile.Assessing_each_aspect_divide")), 1),
                    (_ctx.$i18n.getLocale(0) == 'en')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "fs-20 fw-700 mt-40 culture-profile-title",
                          innerHTML: _ctx.oaicArchetypes.scenarios.dominantCharacteristics.description
                        }, null, 8, _hoisted_36))
                      : _createCommentVNode("", true),
                    (_ctx.$i18n.getLocale(0) == 'th')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "fs-20 fw-700 mt-40 culture-profile-title",
                          innerHTML: 
            _ctx.oaicArchetypes.scenarios.dominantCharacteristics.description_th
          
                        }, null, 8, _hoisted_37))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.OAIC_dominant_characteristicsMax > -1
              ? _ctx.OAIC_dominant_characteristicsMax
              : 0) + " " + _toDisplayString(_ctx.$t("assessmentTest.POINTS_REMAINING")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oaicArchetypes.scenarios.dominantCharacteristics
            .questions, (question) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: question.key,
                        class: "fill-number-form"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          pattern: "\\d*",
                          class: _normalizeClass(["input-points", {
                validate: !_ctx.validateGroupValue('dominantCharacteristics'),
              }]),
                          "onUpdate:modelValue": ($event: any) => ((question.value) = $event),
                          onInput: ($event: any) => (
                _ctx.onChangeWeight($event, 'dominantCharacteristics', question)
              )
                        }, null, 42, _hoisted_39), [
                          [_vModelText, question.value]
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", {
                            class: "bg-points",
                            style: _normalizeStyle(`width: ${question.value}%;`)
                          }, null, 4),
                          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.lang(question, "title")), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.step == 'OAIC_archetypes_2_6')
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                (_ctx.oaicArchetypes.scenarios)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.lang(_ctx.oaicArchetypes.scenarios.organizationalLeadership, "title")) + " (" + _toDisplayString(_ctx.oaicArchetypes.scenarios.organizationalLeadership.order) + "/6) ", 1),
                      _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("question.cultureProfile.Assessing_each_aspect_divide")), 1),
                      (_ctx.$i18n.getLocale(0) == 'en')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "fs-20 fw-700 mt-40 culture-profile-title",
                            innerHTML: _ctx.oaicArchetypes.scenarios.organizationalLeadership.description
                          }, null, 8, _hoisted_46))
                        : _createCommentVNode("", true),
                      (_ctx.$i18n.getLocale(0) == 'th')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "fs-20 fw-700 mt-40 culture-profile-title",
                            innerHTML: 
            _ctx.oaicArchetypes.scenarios.organizationalLeadership.description_th
          
                          }, null, 8, _hoisted_47))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.OAIC_organizational_leadershipMax > -1
              ? _ctx.OAIC_organizational_leadershipMax
              : 0) + " " + _toDisplayString(_ctx.$t("assessmentTest.POINTS_REMAINING")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oaicArchetypes.scenarios.organizationalLeadership
            .questions, (question) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: question.key,
                          class: "fill-number-form"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            pattern: "\\d*",
                            class: _normalizeClass(["input-points", {
                validate: !_ctx.validateGroupValue('organizationalLeadership'),
              }]),
                            "onUpdate:modelValue": ($event: any) => ((question.value) = $event),
                            onInput: ($event: any) => (
                _ctx.onChangeWeight($event, 'organizationalLeadership', question)
              )
                          }, null, 42, _hoisted_49), [
                            [_vModelText, question.value]
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", {
                              class: "bg-points",
                              style: _normalizeStyle(`width: ${question.value}%;`)
                            }, null, 4),
                            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.lang(question, "title")), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.step == 'OAIC_archetypes_3_6')
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  (_ctx.oaicArchetypes.scenarios)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.lang(_ctx.oaicArchetypes.scenarios.managementOfEmployees, "title")) + " (" + _toDisplayString(_ctx.oaicArchetypes.scenarios.managementOfEmployees.order) + "/6) ", 1),
                        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("question.cultureProfile.Assessing_each_aspect_divide")), 1),
                        (_ctx.$i18n.getLocale(0) == 'en')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "fs-20 fw-700 mt-40 culture-profile-title",
                              innerHTML: _ctx.oaicArchetypes.scenarios.managementOfEmployees.description
                            }, null, 8, _hoisted_56))
                          : _createCommentVNode("", true),
                        (_ctx.$i18n.getLocale(0) == 'th')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "fs-20 fw-700 mt-40 culture-profile-title",
                              innerHTML: _ctx.oaicArchetypes.scenarios.managementOfEmployees.description_th
                            }, null, 8, _hoisted_57))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.OAIC_management_of_employeesMax > -1
              ? _ctx.OAIC_management_of_employeesMax
              : 0) + " " + _toDisplayString(_ctx.$t("assessmentTest.POINTS_REMAINING")), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oaicArchetypes.scenarios.managementOfEmployees
            .questions, (question) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: question.key,
                            class: "fill-number-form"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              pattern: "\\d*",
                              class: _normalizeClass(["input-points", {
                validate: !_ctx.validateGroupValue('managementOfEmployees'),
              }]),
                              "onUpdate:modelValue": ($event: any) => ((question.value) = $event),
                              onInput: ($event: any) => (
                _ctx.onChangeWeight($event, 'managementOfEmployees', question)
              )
                            }, null, 42, _hoisted_59), [
                              [_vModelText, question.value]
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", {
                                class: "bg-points",
                                style: _normalizeStyle(`width: ${question.value}%;`)
                              }, null, 4),
                              _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.lang(question, "title")), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.step == 'OAIC_archetypes_4_6')
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    (_ctx.oaicArchetypes.scenarios)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.lang(_ctx.oaicArchetypes.scenarios.organizationGlue, "title")) + " (" + _toDisplayString(_ctx.oaicArchetypes.scenarios.organizationGlue.order) + "/6) ", 1),
                          _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t("question.cultureProfile.Assessing_each_aspect_divide")), 1),
                          (_ctx.$i18n.getLocale(0) == 'en')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "fs-20 fw-700 mt-40 culture-profile-title",
                                innerHTML: _ctx.oaicArchetypes.scenarios.organizationGlue.description
                              }, null, 8, _hoisted_66))
                            : _createCommentVNode("", true),
                          (_ctx.$i18n.getLocale(0) == 'th')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "fs-20 fw-700 mt-40 culture-profile-title",
                                innerHTML: _ctx.oaicArchetypes.scenarios.organizationGlue.description_th
                              }, null, 8, _hoisted_67))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.OAIC_organization_glueMax > -1 ? _ctx.OAIC_organization_glueMax : 0) + " " + _toDisplayString(_ctx.$t("assessmentTest.POINTS_REMAINING")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oaicArchetypes.scenarios.organizationGlue
            .questions, (question) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: question.key,
                              class: "fill-number-form"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                pattern: "\\d*",
                                class: _normalizeClass(["input-points", {
                validate: !_ctx.validateGroupValue('organizationGlue'),
              }]),
                                "onUpdate:modelValue": ($event: any) => ((question.value) = $event),
                                onInput: ($event: any) => (_ctx.onChangeWeight($event, 'organizationGlue', question))
                              }, null, 42, _hoisted_69), [
                                [_vModelText, question.value]
                              ]),
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("div", {
                                  class: "bg-points",
                                  style: _normalizeStyle(`width: ${question.value}%;`)
                                }, null, 4),
                                _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.lang(question, "title")), 1)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.step == 'OAIC_archetypes_5_6')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      (_ctx.oaicArchetypes.scenarios)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.lang(_ctx.oaicArchetypes.scenarios.strategicEmphases, "title")) + " (" + _toDisplayString(_ctx.oaicArchetypes.scenarios.strategicEmphases.order) + "/6) ", 1),
                            _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t("question.cultureProfile.Assessing_each_aspect_divide")), 1),
                            (_ctx.$i18n.getLocale(0) == 'en')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "fs-20 fw-700 mt-40 culture-profile-title",
                                  innerHTML: _ctx.oaicArchetypes.scenarios.strategicEmphases.description
                                }, null, 8, _hoisted_76))
                              : _createCommentVNode("", true),
                            (_ctx.$i18n.getLocale(0) == 'th')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "fs-20 fw-700 mt-40 culture-profile-title",
                                  innerHTML: _ctx.oaicArchetypes.scenarios.strategicEmphases.description_th
                                }, null, 8, _hoisted_77))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.OAIC_strategic_emphasesMax > -1 ? _ctx.OAIC_strategic_emphasesMax : 0) + " " + _toDisplayString(_ctx.$t("assessmentTest.POINTS_REMAINING")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oaicArchetypes.scenarios.strategicEmphases
            .questions, (question) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: question.key,
                                class: "fill-number-form"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  pattern: "\\d*",
                                  class: _normalizeClass(["input-points", {
                validate: !_ctx.validateGroupValue('strategicEmphases'),
              }]),
                                  "onUpdate:modelValue": ($event: any) => ((question.value) = $event),
                                  onInput: ($event: any) => (_ctx.onChangeWeight($event, 'strategicEmphases', question))
                                }, null, 42, _hoisted_79), [
                                  [_vModelText, question.value]
                                ]),
                                _createElementVNode("div", _hoisted_80, [
                                  _createElementVNode("div", {
                                    class: "bg-points",
                                    style: _normalizeStyle(`width: ${question.value}%;`)
                                  }, null, 4),
                                  _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.lang(question, "title")), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.step == 'OAIC_archetypes_6_6')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                        (_ctx.oaicArchetypes.scenarios)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.lang(_ctx.oaicArchetypes.scenarios.criteriaOfSuccess, "title")) + " (" + _toDisplayString(_ctx.oaicArchetypes.scenarios.criteriaOfSuccess.order) + "/6) ", 1),
                              _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.$t("question.cultureProfile.Assessing_each_aspect_divide")), 1),
                              (_ctx.$i18n.getLocale(0) == 'en')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "fs-20 fw-700 mt-40 culture-profile-title",
                                    innerHTML: _ctx.oaicArchetypes.scenarios.criteriaOfSuccess.description
                                  }, null, 8, _hoisted_86))
                                : _createCommentVNode("", true),
                              (_ctx.$i18n.getLocale(0) == 'th')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "fs-20 fw-700 mt-40 culture-profile-title",
                                    innerHTML: _ctx.oaicArchetypes.scenarios.criteriaOfSuccess.description_th
                                  }, null, 8, _hoisted_87))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.OAIC_criteria_of_successMax > -1 ? _ctx.OAIC_criteria_of_successMax : 0) + " " + _toDisplayString(_ctx.$t("assessmentTest.POINTS_REMAINING")), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oaicArchetypes.scenarios.criteriaOfSuccess
            .questions, (question) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: question.key,
                                  class: "fill-number-form"
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    pattern: "\\d*",
                                    class: _normalizeClass(["input-points", {
                validate: !_ctx.validateGroupValue('criteriaOfSuccess'),
              }]),
                                    "onUpdate:modelValue": ($event: any) => ((question.value) = $event),
                                    onInput: ($event: any) => (_ctx.onChangeWeight($event, 'criteriaOfSuccess', question))
                                  }, null, 42, _hoisted_89), [
                                    [_vModelText, question.value]
                                  ]),
                                  _createElementVNode("div", _hoisted_90, [
                                    _createElementVNode("div", {
                                      class: "bg-points",
                                      style: _normalizeStyle(`width: ${question.value}%;`)
                                    }, null, 4),
                                    _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.lang(question, "title")), 1)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.step == 'opened_question')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.$t("assessmentTest.Anyz_feedback_or_thoughts")) + _toDisplayString(_ctx.$t("assessmentTest.culture_profile_q")), 1),
                            _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.$t("assessmentTest.Optional")), 1),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.openedQuestion) = $event)),
                              class: "textrarea-opened-question mt-16",
                              cols: "30",
                              rows: "10"
                            }, null, 512), [
                              [_vModelText, _ctx.openedQuestion]
                            ]),
                            _createElementVNode("div", _hoisted_96, [
                              _createElementVNode("div", {
                                onClick: _cache[6] || (_cache[6] = ($event: any) => ((_ctx.skipOpenEndedQuestion = true), _ctx.finishOpenedQuestion())),
                                class: "ml-auto btn btn-50 btn-c-8D8D8D",
                                style: {"width":"14.4rem"}
                              }, [
                                _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.$t("btn.Skip")), 1)
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["ml-auto btn btn-50 btn-primary ml-12", {
              'disable-true': !_ctx.openedQuestion,
            }]),
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.finishOpenedQuestion && _ctx.finishOpenedQuestion(...args))),
                                style: {"width":"100%"}
                              }, [
                                _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t("btn.Submit")), 1)
                              ], 2)
                            ])
                          ])
                        ]))
                      : (_ctx.step == 'complete')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, [
                              (_ctx.lastSection)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                    _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.$t("assessmentTest.You_ve_completed_this_section")), 1),
                                    _createElementVNode("div", _hoisted_103, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("assessmentTest.Thank_you_for_taking_to_complete")) + " ", 1),
                                      _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.$t("main.Culture_Profile")), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t("assessmentTest.section_of_the_assessment")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.$t("assessmentTest.You_have_completed_all_sections")), 1),
                                    _createElementVNode("div", _hoisted_106, [
                                      _createElementVNode("div", {
                                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.finishAssessment && _ctx.finishAssessment(...args))),
                                        class: "mx-auto btn btn-50 btn-primary",
                                        style: {"margin-top":"8rem"}
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("btn.Close")), 1)
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                    _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.$t("assessmentTest.You_ve_completed_this_section")), 1),
                                    _createElementVNode("div", _hoisted_109, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("assessmentTest.Thank_you_for_taking_to_complete")) + " ", 1),
                                      _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.$t("main.Culture_Profile")), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t("assessmentTest.section_of_the_assessment")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.$t("assessmentTest.Once_you_re_ready")), 1),
                                    _createElementVNode("div", _hoisted_112, [
                                      _createElementVNode("div", {
                                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.nextSectionBTN())),
                                        class: "mx-auto btn btn-50 btn-primary",
                                        style: {"margin-top":"8rem"}
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("assessmentTest.Go_to_the_Next_Section")), 1),
                                        _hoisted_113
                                      ])
                                    ])
                                  ]))
                            ])
                          ]))
                        : _createCommentVNode("", true)
    ]),
    (_ctx.partAnwser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_114))
      : _createCommentVNode("", true)
  ], 64))
}